import { render, staticRenderFns } from "./PMImageUploadModal.vue?vue&type=template&id=106b7a95&"
import script from "./PMImageUploadModal.vue?vue&type=script&lang=ts&"
export * from "./PMImageUploadModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMImageUploadModal.vue?vue&type=style&index=0&id=106b7a95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports